import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import { TDocument } from '../types'
//
import '../utils/fonts'

const styles = StyleSheet.create({
	page: {
		flexDirection: 'row',
		backgroundColor: '#E4E4E4',
	},
	section: {
		margin: 10,
		padding: 10,
		flexGrow: 1,
	},
})

function Test({ doc }: { doc: TDocument }) {
	return (
		<Document>
			<Page size={`A4`} style={styles.page}>
				<View style={styles.section}>
					<Text>Section #1</Text>
				</View>
				<View style={styles.section}>
					<Text>Section #2 {doc?.document?.icdCode}</Text>
				</View>
			</Page>
		</Document>
	)
}

export default Test
